// extracted by mini-css-extract-plugin
export default {"content__mobile":"styles_content__mobile__K5WP0","content__desktop":"styles_content__desktop__KXZ2M"};